import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api";
export const studentApi = createApi({
  reducerPath: "studentApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    getStudentbyUsername: builder.query({
      query: ({ username, Token }) => ({
        url: `/user/profile/${username}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["Student"],
    }),
    getAll: builder.query({
      query: (Token) => ({
        url: "/user",
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["Students", "Student"],
      invalidatesTags: ["Students", "Student"],
    }),

    getStudentInstructor: builder.query({
      query: () => ({
        url: "/user/student-instructor/get",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["InstructorStd"],
    }),

    getSingleStudent: builder.query({
      query: (id) => ({
        url: `/user/${id}`,
        method: "GET",
      }),
      providesTags: ["Student"],
    }),
    getStudentByBatch: builder.query({
      query: (batchName) => ({
        url: `/user/student-by-batch`,
        method: "POST",
        body: {batchName},
      }),
      providesTags: ["Student"],
    }),
    UpadteStudent: builder.mutation({
      query: ({ id, Token, userData }) => ({
        url: `/user/${id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: userData,
      }),
      invalidatesTags: ["Student", "Batch", "Students"],
    }),
    UpdateRank: builder.mutation({
      query: ({ id, Token, rank }) => ({
        url: `/user/${id}/rank`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: { rank },
      }),
      invalidatesTags: ["Student", "Students"],
    }),
    ChangeUserSataus: builder.mutation({
      query: ({ Token, data }) => ({
        url: "/admin/status",
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: data,
      }),
      // Use 'Projects' for providesTags and invalidatesTags
      invalidatesTags: ["Students", "Student", "Fee"],
    }),
  }),
});

export const {
  useGetAllQuery,
  useGetSingleStudentQuery,
  useUpadteStudentMutation,
  useUpdateRankMutation,
  useChangeUserSatausMutation,
  useGetStudentbyUsernameQuery,
  useGetStudentInstructorQuery,
  useGetStudentByBatchQuery,
} = studentApi;
